import SkillsBreakdownTable from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/SkillsBreakdownTable/SkillsBreakdownTable";

export default SkillsBreakdownTable;
